'use client';

import { useTranslations } from 'next-intl';

import { VisualSearchIllustration } from './VisualSearchIllustration';

import { AppUpsellModal } from '@/components/AppUpsellModal';
import { VISUAL_SEARCH_MODAL_TRACKING_ID } from '@/modules/visualSearch/constants';

type Props = {
  isOpen: boolean;
  setOpen: (isOpen: boolean) => void;
  isSheet?: boolean;
};

export function VisualSearchUpsellModal({ isOpen, setOpen, isSheet }: Props) {
  const t = useTranslations('common');

  return (
    <AppUpsellModal
      id="visual-search-upsell-modal"
      isOpen={isOpen}
      setOpen={setOpen}
      isSheet={isSheet}
      title={t('VisualSearch.Title')}
      description={t('VisualSearch.Description')}
      illustration={<VisualSearchIllustration />}
      trackingId={VISUAL_SEARCH_MODAL_TRACKING_ID}
    />
  );
}
